import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { ConfigurationProcedureModel } from 'src/app/models/configuration';

import { FeatureType } from 'src/app/models/EnumTypes';
import { PerformanceAnalysisDTO, PerformanceAnalysisDTOModal } from 'src/app/models/performanceAnalysisDTO';
import { ProcedureModel } from 'src/app/models/procedure';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { EndpointsService } from 'src/app/services/endpoints.service';

import { PointsService } from 'src/app/services/points.service';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { ProgressService } from 'src/app/services/progress.service';
import { TabsService } from 'src/app/services/tabsService';
import GeoJSON from 'ol/format/GeoJSON';

@Component({
  selector: 'app-procedure-vertical-profile',
  templateUrl: './procedure-vertical-profile.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ProcedureVerticalProfileComponent implements OnInit {

  @Input() performanceAnalysisDTO : PerformanceAnalysisDTO;
  performanceAnalysisDTOModal : PerformanceAnalysisDTOModal;
  selectedProcedure : ProcedureModel;

  constructor(public bsModalRef : BsModalRef,
    private pointsService : PointsService,
    private http : HttpClient,
    private endpointsService: EndpointsService,
    private calculationsService : CalculationsService,
    private tabsService: TabsService,
    private procedureControlService: ProcedureControlService,
    private configurationService : ConfigurationService,
    ) {
    this.performanceAnalysisDTOModal = new PerformanceAnalysisDTOModal();
   }

  ngOnInit(): void {
    this.selectedProcedure = cloneDeep(this.pointsService.selectedProcedure);
    this.pointsService.selectedProcedure = null;
  }

  cancelVerticalProfile():void{
    this.bsModalRef.hide();
  }

  async verticalProfileCalculation(){
  this.performanceAnalysisDTO.name = this.performanceAnalysisDTOModal.calculationName;
  this.performanceAnalysisDTO.aircraftSpeed = this.selectedProcedure.aircraftspeed;
  this.performanceAnalysisDTO.resultanalysis = this.performanceAnalysisDTOModal.resultanalysis;
  this.performanceAnalysisDTO.projectId = this.configurationService.currentConfiguration.projectId;
  this.performanceAnalysisDTO.procedureSettings = ConfigurationProcedureModel.mapToCalculation(this.configurationService.currentConfiguration.configurationProcedure);

  let procedureFeature = this.pointsService.getSelectedFeaturesOfType(FeatureType.Procedure);
  this.performanceAnalysisDTO.procedureModel = this.procedureControlService.transformFeatureInProcedure(procedureFeature[0]);
  const geoJsonFormat = new GeoJSON();
  this.performanceAnalysisDTO.procedureFeatureJson = geoJsonFormat.writeFeature(procedureFeature[0]);

  this.http
      .post<any>(
        this.endpointsService.verticalProfileUrl,
        this.performanceAnalysisDTO,
        this.endpointsService.httpOptions
      )
      .subscribe(
        {
          error: (error) => this.calculationsService.showError(error)
        }
      );
  this.bsModalRef.hide();
  }

}
